<div fxLayout="column">
    <mat-card appearance="outlined" class="syn-card">
        <mat-card-header>
            <mat-card-title>{{ subscription?.name }}</mat-card-title>

        </mat-card-header>
        <mat-card-content>
            <mat-form-field class="filter" appearance="outline">
                <mat-label>Filtrer</mat-label>
                <input
                    #filter
                    matInput
                    type="text"
                    (keyup)="applyFilter($event.target.value)"
                    placeholder="Filtrer"
                    [(ngModel)]="query"
                />
                <button
                    mat-icon-button
                    matSuffix
                    (click)="clearQuery()"
                >
                    <mat-icon svgIcon="close"></mat-icon>
                </button>
            </mat-form-field>
            <div fxLayout="row">
                <div>
                    <div synField>
                        <div synFieldLabel>ID</div>
                        <div synFieldValue>{{subscription?.subscriptionId}}</div>
                    </div>

                    <div synField>
                        <div synFieldLabel>Début</div>
                        <!-- todo: i18n -->
                        <div synFieldValue>{{subscription?.startsOn | date:'dd/MM/yyyy'}}</div>
                    </div>

                    <div synField>
                        <div synFieldLabel>Fin</div>
                        <!-- todo: i18n -->
                        <div synFieldValue>{{subscription?.endsOn | date:'dd/MM/yyyy'}}</div>
                    </div>

                    <div synField>
                        <div synFieldLabel>Résiliation</div>
                        <!-- todo: i18n -->
                        <div synFieldValue *ngIf="subscription?.terminationOn?.length; else noTermination">
                            {{subscription?.terminationOn | date:'dd/MM/yyyy'}}
                        </div>
                        <ng-template #noTermination>
                            <div synFieldValue>
                                <small>N/A</small>
                            </div>
                        </ng-template>
                    </div>

                    <div synField>
                        <div synFieldLabel>Périodicité</div>
                        <div synFieldValue>{{subscription?.frequency}}</div>
                    </div>

                    <div synField>
                        <div synFieldLabel>Durée</div>
                        <div synFieldValue>{{subscription?.duration}}</div>
                    </div>

                    <div synField>
                        <div synFieldLabel>Reconduction</div>
                        <div synFieldValue>{{subscription?.renewal}}</div>
                    </div>
                </div>

                <div fxFlex="75">
                    <div fxLayout="column" fxLayoutAlign="space-between end">
                        <mat-table #table [dataSource]="dataSource" matSort fxFlexFill>
                            <!-- code -->
                            <ng-container matColumnDef="code">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Code Article </mat-header-cell>
                                <mat-cell *matCellDef="let row"> {{row.code}} </mat-cell>
                            </ng-container>

                            <!-- name -->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Désignation </mat-header-cell>
                                <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
                            </ng-container>

                            <!-- quantity -->
                            <ng-container matColumnDef="quantity">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Quantité </mat-header-cell>
                                <mat-cell *matCellDef="let row"> {{row.quantity | number}} </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>

                        <mat-paginator *ngIf="showPaginator" #paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
